import React, { Component } from 'react';
import PropTypes from 'prop-types';

class Iframe extends Component {

  componentDidMount() {
    this.iframeRef.onload = () => {
      this.props.onLoad();
    };
  }

  render() {
    return (
      <iframe
        ref={ref => this.iframeRef = ref}
        {...this.props}
      />
    );
  }

}

Iframe.propTypes = {
  onLoad: PropTypes.func.isRequired
};

export default Iframe;
